import React from 'react';
import { Box, Text } from '@bechtel/gds';
import { map } from 'lodash';
// @ts-ignore: tsc declarations not recognising types/index.d.ts
import { ReactComponent as SearchResultsImage } from '@bechtel/client-assets/dist/images/search-results.svg';
import { DocumentLinkStyled } from '~/detail/document-manager/styled';
import { DrawingListStyled } from './styled';
import { t, Trans } from '@lingui/macro';

export interface DrawingListItem {
  drawingNumber: string;
  associatedTagNumbers: (string | undefined)[];
}
export interface DrawingListProps {
  drawings?: DrawingListItem[];
  onSelect: (drawing: DrawingListItem) => void;
  selectedDrawingNo?: string;
}

export const DrawingList: React.FC<DrawingListProps> = ({ drawings, onSelect, selectedDrawingNo }) => {
  return (
    <>
      {drawings?.length ? (
        <DrawingListStyled flexDirection={{ sm: 'column' }}>
          {map(drawings, (drawing) => {
            return (
              <DocumentLinkStyled
                onClick={() => onSelect(drawing)}
                key={drawing.drawingNumber}
                isSelected={selectedDrawingNo === drawing.drawingNumber}
                data-testid="document-link"
              >
                <Box justifyContent={{ sm: 'space-between' }} flexDirection={{ sm: 'column' }}>
                  <Box mb={{ sm: '400' }}>
                    <Text weight="600" size="400">
                      {drawing.drawingNumber}
                    </Text>
                  </Box>
                  <Text color="grey.600" size="300">
                    {t`Tag`}:
                    {drawing?.associatedTagNumbers?.length > 1
                      ? `${drawing?.associatedTagNumbers[0]} (+ ${drawing?.associatedTagNumbers?.length -
                          1} ${t`more tags...`})`
                      : drawing.associatedTagNumbers[0]}
                  </Text>
                </Box>
              </DocumentLinkStyled>
            );
          })}
        </DrawingListStyled>
      ) : (
        <Box flexDirection={{ sm: 'column' }} px={{ sm: '600' }} py={{ sm: '900' }} alignItems={{ sm: 'center' }}>
          <Box mb={{ sm: '500' }}>
            <Text color="grey.600" family="graphik">
              <Trans>No drawings to show</Trans>
            </Text>
          </Box>
          <SearchResultsImage></SearchResultsImage>
        </Box>
      )}
    </>
  );
};
